import { render, staticRenderFns } from "./WeightBalance.vue?vue&type=template&id=7c7b80d4"
import script from "./WeightBalance.vue?vue&type=script&lang=js"
export * from "./WeightBalance.vue?vue&type=script&lang=js"
import style0 from "./WeightBalance.vue?vue&type=style&index=0&id=7c7b80d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports